"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var arrowLeft2 = exports.arrowLeft2 = { "viewBox": "0 0 16 16", "children": [{ "name": "path", "attribs": { "fill": "#000000", "d": "M6.293 13.707l-5-5c-0.391-0.39-0.391-1.024 0-1.414l5-5c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293h9.586c0.552 0 1 0.448 1 1s-0.448 1-1 1h-9.586l3.293 3.293c0.195 0.195 0.293 0.451 0.293 0.707s-0.098 0.512-0.293 0.707c-0.391 0.391-1.024 0.391-1.414 0z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/icomoon/arrowLeft2.js
// module id = 166
// module chunks = 0